<template>

    <v-card>

        <v-card-title class="headline grey darken-4">
            Consulta de Preço
            <v-spacer></v-spacer>

        </v-card-title>


        <v-card-text class="pt-4">
            <v-container>

                <v-row>
                    <v-col cols="12">
                        <Input v-model="barcode" @keydown.enter="checkPrice(barcode)"></Input>
                    </v-col>
                </v-row>

                <v-row v-if="product.name">
                    <v-divider class="pa-5"></v-divider>
                </v-row>

                <v-row v-if="product.name">

                    <v-col cols="12">
                        <h3 class="mb-2">{{ product.name }}</h3>
                        <div class="text-subtitle-1">
                            <span class="font-weight-bold">{{ product.price | currency }}</span>
                            <span v-if="product.wholesale_quantity" class="grey--text"> a partir de {{
                                product.wholesale_quantity }} unid.</span>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
    import { mapActions, mapState } from "vuex";
    export default {

        data() {
            return {
                barcode: "",
                product: {},
            };
        },

        methods: {

            checkPrice(barcode) {
                axios
                    .get(`/api/search/ean/${barcode}`)
                    .then((response) => {
                        this.product = response.data.data;

                        this.barcode = "";
                    })
                    .catch((error) => {
                        this.barcode = "";
                        this.$toast.error("Produto não encontrado");
                    });
            },


        },
    };
</script>
